module.exports = __webpack_public_path__ + "static/media/ravioli.dc9baf33.jpg";